import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '여러분은 가로등이 스스로 밝기를 조절하고, 실시간 데이터를 통해 버스가 정시에 도착하며, 쓰레기통이 가득 차면 자동으로 수거되는 도시를 상상해 본 적이 있나요? 이것이 바로 스마트 시티(Smart City)의 비전입니다. 스마트 시티는 기술과 데이터를 결합해 삶의 질을 높이고, 자원을 최적화하며, 지속 가능한 미래를 만드는 도시입니다. 그렇다면 스마트 시티란 무엇이고, 어떻게 작동하며, 왜 전 세계적인 트렌드가 되었을까요? 이 글을 통해 함께 알아봅시다!',
  keywords: '스마트 시티, Smart city, IoT, AI, 스마트 교통',
  ogSite: '스마트 시티 (Smart City)란 무엇인가?',
  title: '스마트 시티 (Smart City)란 무엇인가?',
  ogUrl: 'https://orbro.io/blog/smartCity',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_GMxdYupJUOC-JJYIFSdsyqG6_x8hDJe1kvmDrClpSR5K6hcvuxYTJQ9XXOtsimWX9HFt4qiOW3AeZmb3ZVy_bpVvxwfp3BKmyOnIW_NP2c-I6-iy3CpGuOh1QGTiQ3Dx00KWOQUm21s-vnwaD_OR6oUb18LIXA-0vf96whel90Bgd42cOfbmNRSWwPsLE68GcSKy-uBlF6_qPymqmQJtnGB-TXir21Yq9n2G-ajASTXm0O0m6rzjUWVdpazxDaJDdpLUXDpUWy0IY1I5LanTNy72ekTYC5HBkRkbVDwssmD3aTErHiOC2QpeqM-W-BcMPIaiIonbR1qLgXGEqu30-ZZfnU0O5b3WOoffemul-rkgSbPLzjctgd6nOt_8BPpB3o_mALSJ-9NcMOd51vLkEy99AUob81CTgk96HqU7B32zM4YPQQGFW58arYirONJTNWnEdzXA1gGT8XQGHr2LNAtFVcAPHJfJI4rpwN9KotYijL-STFfge1F_THgiZKr1is0OsWwoRNZ8Z_OAxlhIlZtF490GarHNYS4G1VrMVbD9f0A9kdBz8X2rqbxarhDynZJoYAbVQIrNbgOyp75tDt7tl5Fk_z8s8lqhudChzRTpinQv3pDUIgGZo_h1Rgym0Pg7_5ytIq7qwZ7GTwTJLHGz3sqdyu7wrSmJ9KLQ3-_TunxMcbluiiiuWhCfRbJWaQx2xeQhzT-zRujZOyFMU-Kcj3Bser-nHCT-2ivZrh0HCD5jCS9RQpKo_M9MEFXdBmbWtRNJ-AypRgC-9D-ijb4ypDo95v2DQhFGiCCsu3hAuW1YJNlgKBDUZ4uIYoO7zOxmZS7TCKfZ_UEPxIY-zzIVfDmcrRvgS9E9TAMzUcouavDiFnv2JhIaFriOgAbgsZP3SIXwdNCTnqJaaaf_gtCWtuEDN3gxtWinlZJxDwd1XuoMLwPFoXsUhmsX3708K6WOdVFNgyfo-5iEGElrW4aF7mpNdaGhbaJDv1_rTIio5NjGvvHEdzad5CSpUSb7oNUt0vCMe8sl02vujUUTWoru3m6Vm6ZZimQB-RmA9XON2Jw5_OTpVqxOJ8DYpgnLL2OdpCooU0LoglXnym7RxeYCpGF-XALQPihewM5N-7Y541ml9Q_pOWhf6lWUGpzXTLBJnDRZK6I9SZ0KDzSKwAQxpLizFNm9PF2U8GtBsvvrytHoNE7xaibd1rOLbrivlcZfEKOYF49IMEebERfOknZU61NrXlHTH-wjSn_syBAg1oNMdvjpFuBr3L8TUBC2zAWsFw_fyN2Fii8tPGK0N4dFnUEDUff9VY2qClf10Cnj3HyfWr1jtQyByw7sYko4s3oEZZq07RXVJcUIABu3Rt2PF46YBV8bMtMXlkuZJUGc7CTB_inyBJlc2I2cDEftd1Tsv0ylC6DrFtQYyh52Wpm6k401h4Wn6uKdXJQVL8pQtuSM6aGamivx-oZeJq_MF9r6XxBwJvLNjyjWIvF_qpD8JKw8OP_DCDCz8X0GYjwsZBTaF8j3bX40unU1orrCz9DuthV-ksDReRU75qiLGGgmMCAhesyy-HnNduDEySg-bTr9vNuc_f2SolSw_JgFjxGKvjjwpZQY7cboPZ8w6wvQuPRNPT9-r6oBxMOg=w1418-h1414?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-07',
  tag1: '#스마트시티',
  tag2: '#Smartcity',
  tag3: '#IoT',
  tag4: '#AI #스마트교통',
  text: [
    {
      head: '',
      subHead: '',
      desc: '여러분은 가로등이 스스로 밝기를 조절하고, 실시간 데이터를 통해 버스가 정시에 도착하며, 쓰레기통이 가득 차면 자동으로 수거되는 도시를 상상해 본 적이 있나요? 이것이 바로 스마트 시티(Smart City)의 비전입니다. 스마트 시티는 기술과 데이터를 결합해 삶의 질을 높이고, 자원을 최적화하며, 지속 가능한 미래를 만드는 도시입니다. 그렇다면 스마트 시티란 무엇이고, 어떻게 작동하며, 왜 전 세계적인 트렌드가 되었을까요? 이 글을 통해 함께 알아봅시다!',
      dot: ''
    },
    {
      head: '1. 스마트 시티란?',
      subHead: '',
      desc: '스마트 시티(Smart City)는 사물인터넷(IoT), 인공지능(AI), 빅데이터(Big Data)와 같은 첨단 기술과 지속 가능한 솔루션을 활용해 주민의 삶의 질을 개선하고, 도시 운영 효율성을 높이며, 환경 영향을 최소화하는 개념입니다.',
      dot: ''
    },
    {
      head: '2. 스마트 시티의 핵심 구성 요소',
      subHead: '',
      desc: '스마트 시티가 되기 위해서는 다음과 같은 기술과 솔루션이 통합되어야 합니다.\n\n사물인터넷(IoT)\n기능: IoT 센서는 대기 질, 오염 수준, 교통 흐름 등 도시 곳곳에서 데이터를 수집합니다.\n예시: 스마트 쓰레기통에 설치된 센서가 쓰레기통이 가득 찼을 때 수거팀에 알림을 보내 수거 일정을 최적화합니다.\n\n빅데이터(Big Data) 및 분석\n기능: 방대한 데이터를 처리해 자원 관리, 공공 서비스, 도시 계획에 대한 스마트한 결정을 내립니다.\n예시: 교통 데이터를 분석해 교통 체증을 예측하고 버스 노선을 조정합니다.\n\n인공지능(AI) 및 머신러닝\n기능: 프로세스를 자동화하고, 과거 데이터를 바탕으로 트렌드를 예측하며, 서비스를 최적화합니다.\n예시: AI가 스마트 전력망을 관리해 전기를 효율적으로 분배하고 낭비를 줄입니다.\n\n지속 가능한 에너지\n기능: 태양광, 풍력 등 재생 에너지와 스마트 전력망을 활용해 탄소 배출을 줄입니다.\n예시: 태양광 가로등이 자연광과 움직임에 따라 자동으로 켜지고 꺼집니다.\n\n스마트 교통\n기능: 자율주행차, 실시간 교통 관리 시스템, 스마트 대중교통을 통합합니다.\n예시: 버스가 교통 체증을 피해 경로를 자동 조정해 정시에 정류장에 도착합니다.\n\n공공 안전 강화\n기능: 스마트 카메라, 센서, AI를 활용해 범죄를 예측하고 예방합니다.\n예시: 얼굴 인식 카메라가 군중 속에서 용의자를 식별해 경찰에 도움을 줍니다.',
      dot: ''
    },
    {
      head: '3. 스마트 시티의 이점',
      subHead: '',
      desc: '스마트 시티는 주민의 삶과 도시 운영을 개선하는 다양한 이점을 제공합니다.\n\n삶의 질 향상\n주민들은 더 나은 대중교통, 깨끗한 공기, 안전한 환경과 같은 공공 서비스를 누립니다.\n예시: 모바일 앱으로 주민이 도로 파손과 같은 문제를 신고하면 즉시 당국의 응답을 받을 수 있습니다.\n\n지속 가능성 증대\n스마트 관리를 통해 에너지, 물, 자원 소비를 줄입니다.\n예시: 토양 습도를 감지해 자동으로 관수량을 조절하는 시스템이 물을 절약합니다.\n\n경제 성장 촉진\n기술 분야의 일자리 창출과 도시 경쟁력을 높여 투자를 유치합니다.\n예시: 스마트 시티는 기술 기업들이 사무실을 열도록 유도해 수천 개의 일자리를 창출합니다.\n\n효율적인 자원 관리\n전기, 물, 공공 공간과 같은 자원을 최적화해 배분합니다.\n예시: 스마트 전력망이 수요가 높은 지역으로 전력을 자동 전환해 과부하를 방지합니다.\n\n주민 참여 강화\n디지털 플랫폼을 통해 주민들이 의사 결정 과정에 참여하고 의견을 제시할 수 있습니다.\n예시: 주민들이 지역사회 개발 프로젝트에 투표할 수 있는 앱이 있습니다.',
      dot: ''
    },
    {
      head: '4. 스마트 시티 구축의 도전 과제',
      subHead: '',
      desc: '스마트 시티는 많은 가능성을 제공하지만, 다음과 같은 도전 과제도 있습니다.\n\n높은 초기 투자 비용\nIoT, AI, 스마트 인프라 구축에는 막대한 자금이 필요합니다.\n솔루션: 공공-민간 파트너십 또는 단계별 투자를 통해 재정 부담을 줄입니다.\n\n데이터 보안 및 개인정보 보호\n대규모 데이터 수집은 사이버 보안 위험과 개인정보 침해 가능성을 초래할 수 있습니다.\n솔루션: 데이터 암호화 및 개인정보 보호 규정을 준수합니다.\n\n디지털 격차\n모든 주민이 기술에 접근할 수 있는 것은 아니므로 불평등이 발생할 수 있습니다.\n솔루션: 디지털 교육에 투자하고 전통적인 공공 서비스 채널을 병행 제공합니다.',
      dot: ''
    },
    {
      head: '5. 스마트 시티의 실제 사례',
      subHead: '',
      desc: '전 세계 여러 도시가 스마트 시티 이니셔티브를 성공적으로 구현하고 있습니다.\n\n싱가포르: IoT와 AI를 활용해 교통, 에너지, 공공 서비스를 관리합니다. 자동 도로 요금 시스템(ERP)은 도심 차량 흐름을 제어합니다.\n\n바르셀로나: IoT 센서를 활용해 물 절약, 스마트 가로등, 자동 주차 시스템을 운영하며 운영 비용을 30% 절감했습니다.\n\n암스테르담: 스마트 전력망과 전기차 공공 시스템을 도입해 2050년까지 탄소 배출 제로 목표를 추구합니다.\n\n주목할 사례: 싱가포르는 스마트 물 관리 시스템으로 매년 수백만 리터의 물을 절약하며 선도적인 스마트 시티로 꼽힙니다.',
      dot: ''
    },
    {
      head: '6. 결론',
      subHead: '',
      desc: '스마트 시티는 단순한 기술 개념이 아니라, 삶의 질을 높이고, 자원을 효율적으로 사용하며, 주민들이 더 긴밀히 연결된 지속 가능한 도시의 미래 비전입니다. 스마트 교통, 지속 가능한 에너지, 공공 안전 등 스마트 시티는 21세기 우리의 삶과 일하는 방식을 새롭게 정의하고 있습니다.\n\n여러분은 이 도시 혁명의 일원이 될 준비가 되었나요? 지금 스마트 시티를 탐구하고 기여함으로써 우리 모두를 위한 더 밝은 미래를 만들어 보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
